"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.setOpen = exports.setText = exports.get = void 0;
var clickEater_sidecar_1 = require("@uiParts/clickEater-sidecar");
var stevieTexts2_sidecar_1 = require("@uiParts/stevieTexts2-sidecar");
var echoFonts_sidecar_1 = require("@echo/echoFonts-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var voyageUiCanvas_sidecar_1 = require("@voyage/ui/voyageUiCanvas-sidecar");
var voyageUiGButtons_sidecar_1 = require("@voyage/ui/voyageUiGButtons-sidecar");
var voyageUiGraphicsUtils_sidecar_1 = require("@voyage/ui/voyageUiGraphicsUtils-sidecar");
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
        exports.setOpen(false);
        render();
    }
    return _obj;
}
exports.get = get;
var create = function () {
    var tw = 600;
    var th = 700;
    var canvas = voyageUiCanvas_sidecar_1.voyageUiCanvas.create(tw, th, voyageLayers_sidecar_1.voyageLayers.getLayers().uiMessage);
    canvas.autoOffset = false;
    var obj = voyageUiCanvas_sidecar_1.voyageUiCanvas.assign(canvas, {
        textTitle: 'Title',
        textDesc: 'Desc',
        onOk: function () { },
    });
    obj.buttons = [
        voyageUiGButtons_sidecar_1.voyageUiGButtons.create('Ok', 50, 50, function () {
            get().onOk();
            exports.setOpen(false);
        }),
    ];
    return obj;
};
var setText = function (text, desc) {
    var obj = get();
    obj.textTitle = text;
    obj.textDesc = desc;
};
exports.setText = setText;
var render = function () {
    var obj = get();
    var g = obj.graphics;
    voyageUiCanvas_sidecar_1.voyageUiCanvas.clear(obj);
    var addText = function (text, x, y) {
        var _text = stevieTexts2_sidecar_1.stevieTexts2.create(echoFonts_sidecar_1.echoFonts.getData().font6, x, y, obj.layer);
        stevieTexts2_sidecar_1.stevieTexts2.setText(_text, text);
        stevieTexts2_sidecar_1.stevieTexts2.setScale(_text, 3);
        obj.texts.push(_text);
        return _text;
    };
    g.clear();
    var gb = voyageCamera_sidecar_1.voyageCamera.getGameBounds();
    g.fillStyle(0x222222, 0.67);
    g.fillRect(0, 0, gb.width, gb.height);
    var w = obj.targetWidth;
    var h = obj.targetHeight;
    var x = (gb.width - w) / 2;
    var y = (gb.height - h) / 2;
    voyageUiGraphicsUtils_sidecar_1.voyageUiGraphicsUtils.bevelPanel(g, x, y, w, h);
    addText(obj.textTitle, x + 6, y);
    var textDesc = addText(obj.textDesc, x + 6 + 20, y + 40);
    stevieTexts2_sidecar_1.stevieTexts2.setWrapWidth(textDesc, obj.targetWidth - 50);
    x += 20;
    y += h - 60;
    obj.buttons[0].x = x;
    obj.buttons[0].y = y;
    voyageUiCanvas_sidecar_1.voyageUiCanvas.render(obj);
};
var setOpen = function (isOpen, onOk) {
    if (onOk === void 0) { onOk = function () { }; }
    var obj = get();
    voyageUiCanvas_sidecar_1.voyageUiCanvas.setOpen(obj, isOpen);
    obj.onOk = onOk;
    if (isOpen) {
        exports.update();
    }
};
exports.setOpen = setOpen;
var update = function () {
    var obj = get();
    if (obj.isOpen) {
        voyageUiCanvas_sidecar_1.voyageUiCanvas.update(obj);
        render();
        clickEater_sidecar_1.clickEater.tempEatCursor();
    }
    else {
        voyageUiCanvas_sidecar_1.voyageUiCanvas.clear(obj);
    }
};
exports.update = update;
